import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posActiveSessionsWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.active-sessions",
  name: "Active sessions",
  description: "Active sessions for the selected dashboard period.",
  apps: [
    "point-of-sale",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.sessions",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "session_status",
        operator: "eq",
        value: "open",
      },
    },
  },
  inputs: {
    label: "Active sessions",
    subtext: "in the last 30 days",
    icon: "briefcase",
    color: "azure",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 7,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
